import Permissions from '@security/permissions';
import PermissionChecker from '@modules/iam/permission-checker';

export class SubprogramPermissions {
  constructor(currentUser) {
    const permissionChecker = new PermissionChecker(
      currentUser,
    );

    this.read = permissionChecker.match(
      Permissions.values.subprogramRead,
    );
    this.import = permissionChecker.match(
      Permissions.values.subprogramImport,
    );
    this.subprogramAutocomplete = permissionChecker.match(
      Permissions.values.subprogramAutocomplete,
    );
    this.create = permissionChecker.match(
      Permissions.values.subprogramCreate,
    );
    this.edit = permissionChecker.match(
      Permissions.values.subprogramEdit,
    );
    this.destroy = permissionChecker.match(
      Permissions.values.subprogramDestroy,
    );
  }
}
